import React from "react";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import InputField from "../../../components/Controls/InputField/InputField";
import { SelectComponent } from "../../../components/Controls/Select/Select";
import * as actions from "../../../store/users/actions";
import { injectIntl } from "react-intl";
import './style.scss';

const Filterform = ({ intl: { messages }, setSearchValues }) => {
  const dispatch = useDispatch();
  const payload = { page: 1, sort: "created_at,desc" };
  const usersList = [
    {id: -1, name: messages.users.position_placeholder},	
    {id: 1, name: messages.users.admin},
    {id: 2, name: messages.users.receptionist},
    {id: 3, name: messages.users.coordinator},
    {id: 4, name: messages.users.specialist},
    {id: 5, name: messages.users.accountant},
  ]
  const initialValues = {
    search: "",
    roleId: -1, //ddl
  };
  const Filterchema = Yup.object().shape({
    search: Yup.string(),
    roleId: Yup.object().nullable(),
  });
  const formik = useFormik({
    initialValues,
    validationSchema: Filterchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {},
  });
  
  const searchWithInput = (e, name) => {
    formik.setFieldValue(name, e.target.value);
    dispatch(
      actions?.internalUsersRequest({
        ...payload,
        search: e.target.value,
        roleId: formik.values.roleId,
      })
    );
    setSearchValues({search: formik.values.search, roleId: formik.values.roleId});
  };

  const searchWithSelect = (e, name) => {
    formik.setFieldValue(name, e.target.value);
    dispatch(
      actions?.internalUsersRequest({
        ...payload,
        search: formik.values.search,
        roleId: e.target.value,
      })
    );
    setSearchValues({search: formik.values.search, roleId: e.target.value});
  };

  return (
    <div>
      <form className="form fv-plugins-bootstrap fv-plugins-framework">
        <div className="row">
          <div className="col-md-4">
            <InputField
              size="small"
              className={'bg-white phone_number'}
              label={messages.users.search}
              id="search"
              name="search"
              value={formik.values.search}
              changeHandler={formik.handleChange}
              error={formik.errors.search}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  searchWithInput(e, "search");
                }
              }}
            />
          </div>
          <div className="col-md-4 selection">
            <SelectComponent
              className={'bg-white'}
              size="small"
              name="roleId"
              list={usersList}
              keyName="name"
              valueKeyName="id"
              value={formik.values.roleId}
              handleChange={(e) => searchWithSelect(e, "roleId")}
              error={formik.errors.requestSource}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default injectIntl(Filterform);
